import { Ranks, nextRank, rankById } from './ranks';

export interface RankProgress {
    rankId: string;
    progress: number;
}

export function rankProgress(rankId: string, progress: number): RankProgress {
    return {
        rankId: rankId,
        progress: progress
    };
}

export function startingRankProgress(): RankProgress {
    return rankProgress(Ranks[0].id, 0);
}

export function addWords(current: RankProgress, word_count: number): RankProgress {
    let progress = current.progress;
    let rank =  rankById(current.rankId);

    for (var i = 0; i < word_count; i++) {
        progress = progress + rank.percentPerWord;
        if (progress >= 100) {
            let extra_progress = progress - 100;
            let extra_progress_fraction_of_word = extra_progress / rank.percentPerWord;
            let next_rank = nextRank(rank);
            // are we maxed out
            if (!next_rank) {
                return rankProgress(rank.id, 100);
            }
            rank = next_rank;
            progress = extra_progress_fraction_of_word * rank.percentPerWord;
        }
    }
    return rankProgress(rank.id, progress);
}